import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { getMerchantInfo } from "./getMerchantInfo";
import { useMemo } from "react";
import { IPaypalMerchantInfo } from "../interfaces";
import { useSelector } from "react-redux";
import { selectCurrentCompany } from "../../../redux/features/user/selectors/userState.selectors";

const NO_COMPANY_ERROR =
  "This action requires x-company-id header, make sure you are authenticated and have a company id.";

export const useGetMerchantInfo = (hydrate: boolean = true): UseQueryResult<IPaypalMerchantInfo> => {
  const company = useSelector(selectCurrentCompany)
  const companyId = useMemo(() => company?.id, [company]);

  const query = useQuery({
    queryKey: ["merchant-info", companyId ?? ""],
    queryFn: () => getMerchantInfo(),
    enabled: !!companyId && !!hydrate,
  });

  if (!companyId)
    throw new Error(NO_COMPANY_ERROR);
  return query;
};